import { ReduxStore } from 'store/types';

function getAllToSelectIsLoading(state: ReduxStore): boolean {
  return state.manufacturer.getAllToSelect.config.isLoading;
}

export default getAllToSelectIsLoading;
